export const TASKS_TO_RESCHEDULE_TYPE = {
  ALL_TASKS: 'allTasks',
  IN_PROGRESS: 'inProgress',
  NOT_STARTED: 'notStarted'
};
